// extracted by mini-css-extract-plugin
module.exports = {"copy":"jgp-L7RXz","bold":"jgp-3bBm4","branded":"jgp-1ir1Q"};